import * as React from 'react';
import { ServicePositionErrorContainer } from './components/ServicePositionError';
import { PublishTermsWrapper } from './components/PublishTermsWrapper';
import { SubAgentLimitExceed } from './components/SubAgentLimitExceed';
import { PackagesContainer } from './components/Packages';
import { PackagesTitleContainer } from './components/PackagesTitle';
import { PlacingTypeSwitcherContainer } from './components/PlacingTypeSwitcher';
import { PublishTermsLoaderContainer } from './components/PublishTermsLoader';
import { PublishTermsError } from './components/PublishTermsError';
import { ServicesContainer } from './components/Services';
import { PlacingPeriodContainer } from './components/PlacingPeriod';
import { PlacingPeriodTitleContainer } from './components/PlacingPeriodTitle';
import { AutoProlongContainer } from './components/AutoProlong';
import { AuctionDesktopContainer } from './components/AuctionDesktop';
import { AuctionMobileContainer } from './components/AuctionMobile';
import { ActionButtonsMobileContainer } from './components/ActionButtonsMobile';
import { SummaryMobileContainer } from '../SummaryMobile';
import { AreaPartsContainer } from './components/AreaParts';

interface IPublishTermsWrapperProps {
  isLoading: boolean;
  isError: boolean;
  isSubagentLimitExceed: boolean;
}

export const PublishTerms = ({ isLoading, isError, isSubagentLimitExceed }: IPublishTermsWrapperProps) => {
  switch (true) {
    case isLoading:
      return (
        <PublishTermsWrapper>
          <PublishTermsLoaderContainer />
        </PublishTermsWrapper>
      );

    case isSubagentLimitExceed:
      return (
        <PublishTermsWrapper>
          <SubAgentLimitExceed />
        </PublishTermsWrapper>
      );

    case isError:
      return (
        <PublishTermsWrapper>
          <PublishTermsError />
        </PublishTermsWrapper>
      );

    default:
      return (
        <PublishTermsWrapper>
          <AreaPartsContainer />
          <ServicesContainer />
          <ServicePositionErrorContainer />
          <PlacingTypeSwitcherContainer />
          <PackagesTitleContainer />
          <PackagesContainer />
          <PlacingPeriodTitleContainer />
          <PlacingPeriodContainer />
          <AutoProlongContainer />
          <AuctionDesktopContainer />
          <AuctionMobileContainer />
          <SummaryMobileContainer />
          <ActionButtonsMobileContainer />
        </PublishTermsWrapper>
      );
  }
};
